export default "__VITE_ASSET__uVUjeNPc__"